import { FC, useCallback } from 'react';
import { useFormContext } from 'react-hook-form';
// Components
import { IconButton } from 'components/Buttons';
import { Tooltip } from 'components/Tooltip';
import Icon from 'components/Icon';
import MultiLanguageTextField from 'components/MultiLanguageTextField';
// i18next
import { useTranslation } from 'react-i18next';
// Utilities
import { isRequired, noWhitespace } from 'utilities/validation';

type Props = {
  index: number;
  questionIndex: number;
  onDelete?: (index:number) => void;

  questionRef: string;
};

const Answer:FC<Props> = ({
  // Props
  index, questionIndex, onDelete, questionRef
}) => {
  const { t } = useTranslation();

  const { watch, formState: { errors } } = useFormContext();

  const name = `questions[${questionIndex}].answers`;
  const watchedAnswer = watch(`${name}.${index}`);

  const handleClick = () => {
    if ( typeof onDelete === 'undefined' ) return;
    onDelete(index);
  }

  const getAnswerError = useCallback(() => {
    if ( !errors || !errors.questions ) return '';

    const question = (errors as any).questions[questionIndex];

    if ( !question || !question.answers ) return '';

    const answer = question.answers[index];

    return answer && answer.title ? answer.title.message : ''
    // eslint-disable-next-line
  }, [errors])();

  if (!watchedAnswer) return null;
  return (
    <div className="flex-grow flex gap-4">
      <MultiLanguageTextField
        rules={{ required: isRequired, validate: noWhitespace }}
        name={`${name}.${index}.title`}
        customKey={`questions[${questionRef}].answers.${watchedAnswer.ref}.title`}
        className="mb-4"
        label={`${t('labels.answer')} ${index + 1}`}
        required={true}
        error={Boolean(getAnswerError)}
        errorText={getAnswerError}
      />
      {typeof onDelete !== 'undefined' ? (
        <div>
          <span className="block mb-1 h-5"></span>
          <Tooltip title={t('buttons.removeAnswer')}>
            <IconButton
              onClick={handleClick}
            ><Icon icon="delete" /></IconButton>
          </Tooltip>
        </div>
      ) : null}
    </div>
  )
}

export default Answer;